import { createSlice } from "@reduxjs/toolkit";

import {
  getHandOverThunk,
  createHandOverThunk,
  updateHandOverThunk,
  deleteHandOverThunk,
  completedHandOverThunk,
} from "state/action/handover";

// Initial state
const initialState = {
  // Get HandOver inisial state
  getHandOver: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Create HandOver inisial state
  createHandOver: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Update HandOver inisial state
  updateHandOver: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  completedHandOver: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  // Delete HandOver inisial state
  deleteHandOver: {
    data: null,
    isFulfilled: false,
    isPending: false,
    isRejected: false,
    err: null,
  },
  createHandOverInputBody: {
    property: "",
    name: "",
    code: "",
    yearContructed: "",
    amenities: [],
    description: "",
  },
  completeHandoverInputBody: {
    lease_agreement: "",
    type: "",
    scheduled_date: "",
    actual_date: "",
    status: "",
    // Peserta serah terima
    participants: {
      tenant_representative: "",
      landlord_representative: "",
    },
    // Pencatatan meteran
    meter_readings: {
      electricity: "", // e.g., "12345.67 kWh"
      water: "", // e.g., "987.65 m³"
      gas: "",
    },
    keys_and_cards: {
      unit_keys: "",
      access_cards: "",
      mailbox_keys: "",
      notes: "",
    },
    checklist: [],

    tenant_signature: "",
    landlord_signature: "",
    general_notes: "",
  },
  selectedHandOver: {
    lease_agreement: "",
    type: "",
    scheduled_date: "",
    actual_date: "",
    status: "",
    // Peserta serah terima
    participants: {
      tenant_representative: "",
      landlord_representative: "",
    },
    // Pencatatan meteran
    meter_readings: {
      electricity: "", // e.g., "12345.67 kWh"
      water: "", // e.g., "987.65 m³"
      gas: "",
    },
    keys_and_cards: {
      unit_keys: "",
      access_cards: "",
      mailbox_keys: "",
      notes: "",
    },
    checklist: [],

    tenant_signature: "",
    landlord_signature: "",
    general_notes: "",
  },
  // HandOver object value
  handover_object_value: "",
};

export const handOverSlice = createSlice({
  name: "handOver",
  initialState,
  reducers: {
    setGetHandOverObjectValue: (state, action) => {
      return {
        ...state,
        handover_object_value: action.payload,
      };
    },
    setCreateHandOverInputBody: (state, action) => {
      return {
        ...state,
        createHandOverInputBody: action.payload,
      };
    },
    setCompleteHandOverInputBody: (state, action) => {
      return {
        ...state,
        completeHandoverInputBody: action.payload,
      };
    },
    setSelectedHandOver: (state, action) => {
      return {
        ...state,
        selectedHandOver: action.payload,
      };
    },
    // note: clear state
    setClearGetHandOverObjectValue: (state, _) => {
      return {
        ...state,
        handover_object_value: "",
      };
    },
    setClearCreateHandOverInputBody: (state, _) => {
      return {
        ...state,
        createHandOverInputBody: {
          property: "",
          name: "",
          code: "",
          yearContructed: "",
          amenities: "",
          description: "",
        },
      };
    },
    setClearGetHandOver: (state, _) => {
      return {
        ...state,
        getHandOver: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearCreateHandOver: (state, _) => {
      return {
        ...state,
        createHandOver: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearUpdateHandOver: (state, _) => {
      return {
        ...state,
        updateHandOver: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearDeleteHandOver: (state, _) => {
      return {
        ...state,
        deleteHandOver: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
      };
    },
    setClearAllHandOverState: (state, _) => {
      return {
        ...state,
        // Get HandOver inisial state
        getHandOver: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Create HandOver inisial state
        createHandOver: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Update HandOver inisial state
        updateHandOver: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // Delete HandOver inisial state
        deleteHandOver: {
          data: null,
          isFulfilled: false,
          isPending: false,
          isRejected: false,
          err: null,
        },
        // HandOver object value
        HandOver_object_value: "",
      };
    },
  },
  extraReducers(builder) {
    builder
      // Get HandOver reducer
      .addCase(getHandOverThunk.pending, (state, _) => {
        return {
          ...state,
          getHandOver: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(getHandOverThunk.fulfilled, (state, action) => {
        return {
          ...state,
          getHandOver: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(getHandOverThunk.rejected, (state, action) => {
        return {
          ...state,
          getHandOver: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      // Create HandOver reducer
      .addCase(createHandOverThunk.pending, (state, _) => {
        return {
          ...state,
          register: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(createHandOverThunk.fulfilled, (state, action) => {
        return {
          ...state,
          register: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(createHandOverThunk.rejected, (state, action) => {
        return {
          ...state,
          register: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      // Completed HandOver reducer
      .addCase(completedHandOverThunk.pending, (state, _) => {
        return {
          ...state,
          completedHandOver: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(completedHandOverThunk.fulfilled, (state, action) => {
        return {
          ...state,
          completedHandOver: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(completedHandOverThunk.rejected, (state, action) => {
        return {
          ...state,
          completedHandOver: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      })
      // update HandOver reducer
      .addCase(updateHandOverThunk.pending, (state, _) => {
        return {
          ...state,
          updateHandOver: {
            data: null,
            isPending: true,
            isFulfilled: false,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(updateHandOverThunk.fulfilled, (state, action) => {
        return {
          ...state,
          updateHandOver: {
            data: action.payload,
            isPending: false,
            isFulfilled: true,
            isRejected: false,
            err: null,
          },
        };
      })
      .addCase(updateHandOverThunk.rejected, (state, action) => {
        return {
          ...state,
          updateHandOver: {
            data: null,
            isPending: false,
            isFulfilled: false,
            isRejected: true,
            err: action.error.message,
          },
        };
      });
  },
});

export const handOverAction = {
  ...handOverSlice.actions,
  getHandOverThunk,
  createHandOverThunk,
  updateHandOverThunk,
  deleteHandOverThunk,
  completedHandOverThunk,
};

export function selectHandOverObjectValue(state) {
  return state?.handover?.handover_object_value;
}

export function selectHandOver(state) {
  return state?.handover;
}

export default handOverSlice.reducer;
